import { SSRMeasures } from '@confluence/action-measures/entry-points/SSRMeasures';

export const SLOW_QUERY_DEFAULT_TIMEOUT =
	process.env.CLOUD_ENV === 'staging' ||
	process.env.CLOUD_ENV === 'branch' ||
	process.env.CLOUD_ENV === 'dev'
		? 1000
		: 500;

export const slowQueryGuard = async (
	name: string,
	task: () => Promise<any>,
	timeout: number,
	skipSignal?: Promise<void>,
): Promise<boolean> => {
	let timer: ReturnType<typeof setTimeout> | null = null;
	const timeoutPromise = new Promise<boolean>((resolve) => {
		timer = setTimeout(() => {
			// eslint-disable-next-line no-console
			console.error(`SlowQueryGuard "${name}" timed out after ${timeout}ms`);
			resolve(false);
		}, timeout);
	});

	const runTask = async () => {
		await SSRMeasures.run(`ssr-app/prepare/preloadQuery/slowQueryGuard:${name}`, task);
		if (timer) {
			clearTimeout(timer);
		}
		return true;
	};

	return Promise.race(
		skipSignal
			? [timeoutPromise, skipSignal.then(() => true), runTask()]
			: [timeoutPromise, runTask()],
	);
};
